module.exports = __webpack_public_path__ + "static/logo-160adcbd704cdcdf5e6391d5a131e309.png";